import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const Dataset = (props: SvgIconProps): React.ReactNode => {
  return (
    <SvgIcon {...props}>
      <rect
        opacity="0.3"
        x="2.9696"
        y="3.27332"
        width="17.7488"
        height="17.7488"
      />
      <path d="M6.72222 17.2778H10.6111V13.3889H6.72222V17.2778ZM13.3889 17.2778H17.2778V13.3889H13.3889V17.2778ZM6.72222 10.6111H10.6111V6.72222H6.72222V10.6111ZM13.3889 10.6111H17.2778V6.72222H13.3889V10.6111ZM3.66667 22C3.22222 22 2.83333 21.8333 2.5 21.5C2.16667 21.1667 2 20.7778 2 20.3333V3.66667C2 3.22222 2.16667 2.83333 2.5 2.5C2.83333 2.16667 3.22222 2 3.66667 2H20.3333C20.7778 2 21.1667 2.16667 21.5 2.5C21.8333 2.83333 22 3.22222 22 3.66667V20.3333C22 20.7778 21.8333 21.1667 21.5 21.5C21.1667 21.8333 20.7778 22 20.3333 22H3.66667ZM3.66667 20.3333H20.3333V3.66667H3.66667V20.3333Z" />
    </SvgIcon>
  )
}

export default Dataset
